// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"604":"3bb9ab3b","638":"aad814db","678":"6eb20d22","751":"451219f5","866":"903619ac"}[chunkId] + ".chunk.js";
};